import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const InfoRoundIcon = ({ style, ...rest }: SVGIconProps) => {
  return (
    <Center style={style} {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clipPath="url(#clip0_1_7944)">
          <path
            d="M10.0019 9.25002C10.4162 9.25002 10.7519 9.58581 10.7519 10V13.6104C10.7519 14.0246 10.4162 14.3604 10.0019 14.3604C9.58773 14.3604 9.25194 14.0246 9.25194 13.6104V10C9.25194 9.58581 9.58773 9.25002 10.0019 9.25002Z"
            fill="#1A1721"
          />
          <path
            d="M9.54165 6.09316C9.7077 5.9822 9.90293 5.92298 10.1026 5.92298C10.3705 5.92298 10.6273 6.02937 10.8167 6.21874C11.006 6.40811 11.1124 6.66495 11.1124 6.93275C11.1124 7.13246 11.0532 7.32769 10.9422 7.49375C10.8313 7.65981 10.6736 7.78923 10.4891 7.86566C10.3046 7.94208 10.1015 7.96208 9.90565 7.92312C9.70978 7.88416 9.52986 7.78799 9.38863 7.64677C9.24741 7.50554 9.15124 7.32562 9.11228 7.12975C9.07332 6.93387 9.09331 6.73084 9.16974 6.54633C9.24617 6.36182 9.37559 6.20412 9.54165 6.09316Z"
            fill="#1A1721"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.36581 4.36386C5.86061 2.86906 7.88798 2.0293 10.0019 2.0293C12.1159 2.0293 14.1433 2.86906 15.6381 4.36386C17.1329 5.85865 17.9726 7.88603 17.9726 9.99999C17.9726 12.1139 17.1329 14.1413 15.6381 15.6361C14.1433 17.1309 12.1159 17.9707 10.0019 17.9707C7.88798 17.9707 5.86061 17.1309 4.36581 15.6361C2.87102 14.1413 2.03125 12.1139 2.03125 9.99999C2.03125 7.88603 2.87102 5.85865 4.36581 4.36386ZM10.0019 3.5293C8.28581 3.5293 6.63996 4.21103 5.42647 5.42452C4.21298 6.63801 3.53125 8.28385 3.53125 9.99999C3.53125 11.7161 4.21298 13.362 5.42647 14.5755C6.63996 15.7889 8.28581 16.4707 10.0019 16.4707C11.7181 16.4707 13.3639 15.7889 14.5774 14.5755C15.7909 13.362 16.4726 11.7161 16.4726 9.99999C16.4726 8.28385 15.7909 6.63801 14.5774 5.42452C13.3639 4.21103 11.7181 3.5293 10.0019 3.5293Z"
            fill="#1A1721"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_7944">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
